import { render, staticRenderFns } from "./SettingEditForm.vue?vue&type=template&id=471e9c2c&"
import script from "./SettingEditForm.vue?vue&type=script&lang=js&"
export * from "./SettingEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports